import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller, useWatch } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import {
  allPerformance,
  allServiceUsed,
} from "../../../../../../../features/admin/common/Slice";
import Select from "react-select";

import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  GetSingle,
  Update,
  GetAll,
  GetByUserId,
} from "../../../../../../../features/admin/quality_management/resource_requirement/externaldetails/Slice";

import { formatDateForInput } from "../../../../../../../utils/common";

function Externally_Service_Edit_Offcanvas({ show, handleClose, id }) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const all_performance = useSelector((state) => state.common.all_performance);
  const all_service_used = useSelector(
    (state) => state.common.all_service_used,
  );

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(allServiceUsed());
    dispatch(allPerformance());
  }, [dispatch]);

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      setLoading(true);
      const res = await dispatch(GetSingle(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.data;

        //map ID → label
        const performance = all_performance?.find(
          (o) => o.value === data.performance_id,
        )?.label;

        const serviceUsed = all_service_used?.find(
          (o) => o.value === data.service_used_id,
        )?.label;

        reset({
          name: data.name || "",
          address: data.address || "",
          contact_no: data.contact_no || "",
          contact_person_name: data.contact_person_name || "",
          email: data.email || "",
          performance_id: data.performance_id || null,
          service_used_id: data.service_used_id || null,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  if (
    show &&
    id &&
    all_performance?.length &&
    all_service_used?.length
  ) {
    GetData(id);
  }
}, [show, id, all_performance, all_service_used]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {
    
    try {
      const sendData = {
        name: data.name,
        address: data.address,
        contact_person_name: data.contact_person_name,
        email: data.email,
        contact_no: data.contact_no,
        performance_id: data.performance_id,
        service_used_id: data.service_used_id,
      };

      const res = await dispatch(Update({ id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetAll());

        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      } else {
        setShowError(res.payload?.response?.data?.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleRemoveCompanies = () => {
    setCompaniesPreview(null);
    setValue("degree", null);
    setRemovedFiles((prev) =>
      prev.includes("degree") ? prev : [...prev, "degree"],
    );
  };

  const handleRemoveAttach = () => {
    setAttachPreview(null);
    setValue("training_certificate", null);
    setRemovedFiles((prev) =>
      prev.includes("training_certificate")
        ? prev
        : [...prev, "training_certificate"],
    );
  };

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Externally Provided Product & Service
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Name of Vendor</Form.Label>
                  <Form.Control
                    {...register("name", {
                      required: "Vendor Name is required",
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    {...register("address", {
                      required: "Address is required",
                    })}
                  />
                  {errors.address && (
                    <span className="text-danger">
                      {errors.address.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Contact Person</Form.Label>
                  <Form.Control
                    {...register("contact_person_name", {
                      required: "Contact Person Name is required",
                    })}
                  />
                  {errors.contact_person_name && (
                    <span className="text-danger">
                      {errors.contact_person_name.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    {...register("email", {
                      required: "Email is required",
                    })}
                  />
                  {errors.email && (
                    <span className="text-danger">{errors.email.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Contact No</Form.Label>
                  <Form.Control
                    {...register("contact_no", {
                      required: "Contact No. is required",
                    })}
                  />
                  {errors.contact_no && (
                    <span className="text-danger">
                      {errors.contact_no.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Service Used</Form.Label>
                  <Controller
                    name="service_used_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Service Used is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_service_used}
                        value={
                          all_service_used?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.service_used_id && (
                    <span className="text-danger">
                      {errors.service_used_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Performance</Form.Label>
                  <Controller
                    name="performance_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Performance is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_performance}
                        value={
                          all_performance?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.performance_id && (
                    <span className="text-danger">
                      {errors.performance_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Externally_Service_Edit_Offcanvas;
